import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-icon-setting',
    templateUrl: './icon-setting.component.html',
    styleUrl: '../icon-shared/icon-shared.scss'
})
export class IconSettingComponent {
    @Input() isActive: boolean = false;
}
